// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IBalanceReminderResponseDto
 */
export interface IBalanceReminderResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof IBalanceReminderResponseDto
     */
    thirty_days_before_banner?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IBalanceReminderResponseDto
     */
    ten_days_before_banner?: boolean;
}

/**
 * Check if a given object implements the IBalanceReminderResponseDto interface.
 */
export function instanceOfIBalanceReminderResponseDto(value: object): value is IBalanceReminderResponseDto {
    return true;
}

export function IBalanceReminderResponseDtoFromJSON(json: any): IBalanceReminderResponseDto {
    return IBalanceReminderResponseDtoFromJSONTyped(json, false);
}

export function IBalanceReminderResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IBalanceReminderResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'thirty_days_before_banner': json['thirty_days_before_banner'] == null ? undefined : json['thirty_days_before_banner'],
        'ten_days_before_banner': json['ten_days_before_banner'] == null ? undefined : json['ten_days_before_banner'],
    };
}

export function IBalanceReminderResponseDtoToJSON(json: any): IBalanceReminderResponseDto {
    return IBalanceReminderResponseDtoToJSONTyped(json, false);
}

export function IBalanceReminderResponseDtoToJSONTyped(value?: IBalanceReminderResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'thirty_days_before_banner': value['thirty_days_before_banner'],
        'ten_days_before_banner': value['ten_days_before_banner'],
    };
}

